// Navigation
export function navigation() {
    const burger = document.querySelector('.burger');
    //const nav = document.querySelector('.site-header');
    const body = document.querySelector('body');

    burger.addEventListener('click', () => {
        body.classList.toggle('show-nav');
        console.log('burger clicked..');
    });
}
